import { PlycaTranslateHttpLoader } from '@/app/_infrastructure/adapters/i18n/plyca-translate-http-loader';
import { HttpClient } from '@angular/common/http';
import { isPlatformBrowser } from '@angular/common';

export function HttpLoaderFactory(http: HttpClient, platformId: Object) {
  const isBrowser = isPlatformBrowser(platformId);
  const prefix = isBrowser ? 'assets/i18n/' : '/assets/i18n/';
  return new PlycaTranslateHttpLoader(http, prefix, '.json');
}
